import { initTimeFormat } from "./utils/time-format";
import { initShare } from "./utils/share";
import { initAbTest } from "./utils/ab-tests";
import { initCopyToClipboard } from "./utils/clipboard";
import { initPricesExpand } from "./utils/pricing-expand";
import { initRating } from "./utils/rating";
import { initSLider } from "./components/slider";
import { initHeaderNav } from "./layout/header-nav";
import { initCountryAndLanguage } from "./layout/footer/country-language";
import { initFooterFixed } from "./layout/footer/footer-fixed";
import { initHomePageHeader } from "./layout/header/homepage-header";
import { initBadges } from "./pages/badges";
import { initContact } from "./pages/contact";
import { initReferenceInvite } from "./pages/reference-invite";
import { initAddReference } from "./pages/reference";
import { shareYourExperience } from "./pages/share-your-experience";
import { initHomepageProfileResearchOptIn } from "./pages/homepage/profile-research-opt-in";
import { initHomepageDialogNextSteps } from "./pages/homepage/dialog-next-steps";
import { initProfileContact } from "./pages/profile/profile-contact";
import { initProfileContactReminder } from "./pages/profile/profile-contact-reminder";
import { initProfileDescription } from "./pages/profile/profile-description";
import { initConversationTextareaCookieValue } from "./pages/conversation/textarea-cookie-value";
import { initConversationUseTheApp } from "./pages/conversation/use-the-app";
import { initConversationCannedResponse } from "./pages/conversation/canned-responses";
import { initConversationMessaging } from "./pages/conversation/messaging";
import { initConversationMessageList } from "./pages/conversation/message-list";
import { initializeFavoriteRive } from "./utils/favorite-btn";
import { initProfileTranslate } from "./pages/profile/profile-translate";
import { initProfileViewedCookie } from "./pages/profile/profile-viewed-cookie";
document.addEventListener("DOMContentLoaded", () => {
    const initializers = [
        //utils
        initTimeFormat,
        initTimeFormat,
        initShare,
        initAbTest,
        initCopyToClipboard,
        initFooterFixed,
        initPricesExpand,
        initRating,
        initializeFavoriteRive,
        //Component
        initSLider,
        //Layout
        initHeaderNav,
        initCountryAndLanguage,
        initHomePageHeader,
        //Pages
        initBadges,
        initContact,
        initReferenceInvite,
        initAddReference,
        shareYourExperience,
        initHomepageProfileResearchOptIn,
        initHomepageDialogNextSteps,
        initProfileContact,
        initProfileContactReminder,
        initProfileDescription,
        initConversationTextareaCookieValue,
        initConversationUseTheApp,
        initConversationCannedResponse,
        initConversationMessaging,
        initConversationMessageList,
        initProfileTranslate,
        initProfileViewedCookie,
    ];
    initializers.forEach((fn) => {
        try {
            fn();
        }
        catch (error) {
            console.error(`❌ ${fn.name} failed:`, error);
        }
    });
});
